var map = {
	"./Logipe_App_qr.png": 75267,
	"./Screenshot 2023-10-07 at 10.06.46 PM.png": 334,
	"./gpay.png": 53480,
	"./paytm.png": 69800,
	"./phonePe.png": 96538,
	"./truck-32.png": 44962,
	"./yesbank.png": 82976,
	"./yesbank2.png": 76336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;